import React, { ReactNode } from 'react';

import { getCustomProperties } from './helpers';

import { ThemeProvider as LibThemeProvider } from 'components/library';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import GlobalStyle from './global-styles';
import themeConfig from './themeConfig';

interface ThemeProviderProps {
  children: ReactNode;
}

const { theme, inline } = themeConfig;

const Provider = ({ children }: ThemeProviderProps) => {
  return (
    <>
      <StyledThemeProvider theme={theme}>
        <LibThemeProvider theme={theme}>
          <GlobalStyle rootVariables={getCustomProperties(inline)} theme={theme} />
          {children}
        </LibThemeProvider>
      </StyledThemeProvider>
    </>
  );
};

export default Provider;
